






































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Section } from '../CvView.vue'
import { Option } from '@app/componentlib/common/types/BootstrapTypes'
import { CV, HelpTextProfile } from '@app/componentlib/common/types/CVTypes'
import ColorThemePicker from '@app/componentlib/src/views/components/ColorThemePicker.vue'
import { CvModule } from '@app/componentlib/src/store/modules/cvdata'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import ArrowNavigation from '@app/componentlib/src/views/components/ArrowNavigation.vue'
import { ga } from '@app/componentlib/src/application/analytics'
import BaseIcon from '@app/componentlib/src/views/components/BaseIcon.vue'
import SaveCloud from '@app/componentlib/src/views/components/icons/SaveCloud.vue'
import { CVMotivationalTexts } from '@app/componentlib/common/types/CVTypes'

interface Template {
  text: string,
  value: number,
  id?: number | undefined
}

@Component<CvStyling>({
  props: {
    section: Object,
    langOptions: Array,
    startFromLast: Boolean,
    helpTextProfile: Object
  },
  components: {
    ColorThemePicker,
    ArrowNavigation,
    BaseIcon,
    SaveCloud
  }, watch: {
    selectedTemplate(optionId: number) {
      //Reset preview urls when selecting template
      CvModule.removePreviewUrls()
      this.selectTemplateOption(optionId)
    },
    selectedProfileExample(value: number) {
      if(this.selectedTemplate === 3) {
        CvModule.removePreviewUrls()
        CvModule.changeSelectedProfile(value)
        ga.event({
          action: 'Profile Example',
          category: 'CV Tool',
          label: value.toString(),
        })
      }
    },
    selectedLang(val) {
      let currentExampleProfile: Template | undefined = undefined
      if(this.selectedProfileExample !== undefined) {
        //Set the current selected example template, to get the correct group id (called id) to find the "same" example profile in another language
        currentExampleProfile = this.exampleProfiles.find(p => p.value === this.selectedProfileExample)
      }
      CvModule.setCvLang(val)
      //Now we have new example profiles. Find the new exampleProfile with the same groupId (id), as the old selected example profile to display the same example profile but with another language
      if(currentExampleProfile !== undefined) {
        const newSelectedExampleProfile = this.exampleProfiles.find(ep => ep.id === currentExampleProfile?.id)
        if(newSelectedExampleProfile !== undefined) {
          this.selectedProfileExample = newSelectedExampleProfile?.value
        } else if(this.exampleProfiles.length > 0) {
          this.selectedProfileExample = this.exampleProfiles[0].value
        }
      } else if(this.exampleProfiles.length > 0) {
        this.selectedProfileExample = this.exampleProfiles[0].value
      }
    },
    helpTextProfile(val) {
      // Match profileId with the selected language when changing helpTextProfiles
      this.templateOptions.find(temp => {
        if(temp.value === 2) {
          temp.id = val?.profileId
        }
      })
      if(this.selectedTemplate === 2) {
        //Find the new selected profile id from the helptext
        const tempOption = this.templateOptions.find(o => o.value === this.selectedTemplate)
        CvModule.changeSelectedProfile(tempOption?.id)
      }
    }
  }
})

export default class CvStyling extends Vue {
  /**
   * Props variables
   */
  section: Section | undefined
  langOptions: Option[] | undefined
  startFromLast: boolean | undefined

  /**
   * Component state variables
   */
  selectedLang: string | null | undefined = null
  selectedTemplate: number | null = 1
  templateOptions: Template[] = [
    { text:  this.t.CV_Tool_Template_Own_Information, value: 1, id: undefined },
    { text:  this.t.CV_Tool_HelpTexts, value: 2, id: undefined },
    { text:  this.t.CV_Tool_Profile_Examples, value: 3, id: undefined }
  ]
  selectedProfileExample: number | null | undefined = null
  setupStep = 1

  useMotivationalTexts: boolean = CvModule.useMotivationalTexts
  timerForHeadline = 0
  timerForText = 0
  validSections: string[] | undefined = undefined
  canHaveMotivationalTexts: boolean = false

  isSaving: boolean = false
  savedComplete: boolean = false
  savedFailed: boolean = false

  /**
   * Lifecycle
   */
  async mounted () {
    if(this.langOptions !== undefined) {
      this.selectedLang = this.langOptions.find(lang => lang.value === this.selected?.language)?.value
    }
    if(this.helpTextProfile !== undefined) {
      this.templateOptions.find(temp => {
        if(temp.value === 2 && this.helpTextProfile !== undefined) {
          temp.id = this.helpTextProfile?.profileId
        }
      })
    }
    //Check if we have an selectedProfileId from before, if we do - find and show it as either an example profile or and selectedTemplate.
    const selectedProfile = CvModule.selectedProfileId
    if(selectedProfile !== null) {
      const exampleProfile = this.exampleProfiles.find(p => p.value === selectedProfile)
      if(exampleProfile !== undefined) {
        this.selectedTemplate = 3
        this.selectedProfileExample = exampleProfile.value
      } else if(selectedProfile === this.helpTextProfile?.profileId) {
        this.selectedTemplate = 2
        //Set first example profile as selected if nothing else was selected before
        this.selectedProfileExample = this.exampleProfiles[0].value
      }
    }
    if(this.startFromLast === true && this.showColorTheme === true){
      this.setupStep = 3
    }
    this.validSections = await CvModule.GetCVSections().then((data: any) => {
      data.find((x: string) => {
        if('TR_RESUME' === x || 'PROFILE_RESUME' === x)
          this.canHaveMotivationalTexts = true
      })

      return data
    })
  }

  /**
   * Getters
   */
  get helpTextProfile (): HelpTextProfile | undefined {
    return CvModule.helpTextProfile
  }
  get t (): any {
    return AppModule.translations
  }
  get isProfileExamples () {
    if(this.selectedTemplate !== undefined) {
      return this.selectedTemplate === 3
    }
    return false
  }

  get exampleProfiles (): Template[] {
    let examples: Template[] = []
    if(this.selected !== null) {
      this.selected?.validExampleProfiles?.forEach(e => {
        examples.push({
          text: e.title,
          value: e.profileId,
          id: e.profileGroupId
        })
      })
    }
    return this.sortExamples(examples)
  }

  get selected (): CV | undefined {
    return CvModule.selectedCv
  }

  get showColorTheme (): boolean {
    //Don't show color themes if we have less than 2 color themes
    const selectedCv = CvModule.selectedCv
    return selectedCv !== null && selectedCv !== undefined && selectedCv.validColorThemes !== null && selectedCv.validColorThemes.length > 1
  }

  get previewUrls (): string[] | undefined {
    return CvModule.previewUrls
  }

  get motivationalHeadline (): string {
    return CvModule.motivationalHeadline
  }

  get motivationalText (): string {
    return CvModule.motivationalText
  }

  get haveExtraMotivationalStep(): boolean {
    return this.selectedTemplate === this.templateOptions[0].value && this.canHaveMotivationalTexts === true
  }

  isValidSection (sectionName: string): boolean {
    let isValid = false

    if(this.validSections !== undefined)
      this.validSections.find((x: string) => {
        if(sectionName === x)
          isValid = true
      })

    return isValid
  }

  sortExamples (items: Template[]) {
    return items.sort(function(a, b) {
      var textA = a.text.toUpperCase() // ignore upper and lowercase
      var textB = b.text.toUpperCase() // ignore upper and lowercase
      if (textA < textB) {
        return -1
      }
      if (textA > textB) {
        return 1
      }

      // texts must be equal
      return 0
    })
  }

  /**
   * Methods
   */
  selectTemplateOption (optionId: number) {
    //set the correct selected profile
    if(optionId === 2) {
      const profile = this.templateOptions.find(temp => temp.value === optionId)
      if(profile !== undefined) {
        CvModule.changeSelectedProfile(profile.id)
        ga.event({
          action: 'HelpText',
          category: 'CV Tool',
          label: profile.id,
        })
      }
      this.useMotivationalTexts = false
      CvModule.setUseMotivationalTexts(false)
    } else if (optionId === 3) {
      if(this.selectedProfileExample !== null && this.selectedProfileExample !== undefined) {
        CvModule.changeSelectedProfile(this.selectedProfileExample)
        ga.event({
          action: 'Profile Example',
          category: 'CV Tool',
          label: this.selectedProfileExample,
        })
      }
      this.useMotivationalTexts = false
      CvModule.setUseMotivationalTexts(false)
    } else {
      CvModule.changeSelectedProfile()
    }
  }

  async changeSection (back?:boolean) {
    if(this.section !== undefined) {
      if(back === true && this.setupStep === 1) {
        this.$emit('changeSection', {path:'1', back:true})
      }

      const selectedProfileId = CvModule.selectedProfileId
      if((this.setupStep === 3 || this.showColorTheme === false) && back !== true) {
        //If we are on step 2 or we only have 1 colortheme and we dont push back and we do not have a selected profile, we go to section 3, if we have a selected profile we got to section 4 (Download).
        //A selected profile cannot be adjusted in CvAdjust component
        if(selectedProfileId === null) {
          this.$emit('changeSection', {path:'3', back:false})
        } else {
          this.$emit('changeSection', {path:'4', back:false})
        }
      }

      if(back === true && this.setupStep === 2) {
        this.setupStep = 1
        ga.event({
          action: 'Change Section',
          category: 'CV Tool',
          label: 'Arrows - styling'
        })
      }
      if(back === true && this.setupStep === 3) {
        this.haveExtraMotivationalStep ? this.setupStep = 2 : this.setupStep = 1
        ga.event({
          action: 'Change Section',
          category: 'CV Tool',
          label: 'Arrows - styling'
        })
      }

      //Only go to step 3 if we are on step 1 and dont go back and we have more than 1 color theme
      if(back !== true && this.setupStep === 1 && this.showColorTheme === true) {
        this.haveExtraMotivationalStep ? this.setupStep = 2 : this.setupStep = 3
        ga.event({
          action: 'Change Section',
          category: 'CV Tool',
          label: 'Arrows - styling'
        })
      }
      else if(back !== true && this.setupStep === 2 && this.showColorTheme === true && this.selectedTemplate === this.templateOptions[0].value) {
        this.setupStep = 3
        ga.event({
          action: 'Change Section',
          category: 'CV Tool',
          label: 'Arrows - styling'
        })
      }
    }
  }

  changeMotivationalHeadline(text: string) {
    this.savedComplete = false
    // Reset timer if this method is called
    if (this.timerForHeadline >= 0) {
      clearTimeout(this.timerForHeadline)
    }
    this.timerForHeadline = window.setTimeout(() => {
      this.isSaving = true
      // Create the motivationalTexts object
      let mt = {
        MotivationalHeadline: text,
        MotivationalText: this.motivationalText
      } as CVMotivationalTexts
      // Send object to backend, and then set some search variables
      CvModule.saveMotivationalTexts(mt).then(() => {
        this.isSaving = false
        this.savedComplete = true
      }).catch(error => {
        console.log(error)
        this.savedFailed = true
      })
    }, 800)
  }

  changeMotivationalText(text: string) {
    this.savedComplete = false
    // Reset timer if this method is called
    if (this.timerForText >= 0 ) {
      clearTimeout(this.timerForText)
    }
    this.timerForText = window.setTimeout(() => {
      this.isSaving = true
      // Create the motivationalTexts object
      let mt = {
        MotivationalHeadline: this.motivationalHeadline,
        MotivationalText: text
      } as CVMotivationalTexts
      // Send object to backend, and then set some search variables
      CvModule.saveMotivationalTexts(mt).finally(() => {
        this.isSaving = false
        this.savedComplete = true
      }).catch(error => {
        console.log(error)
        this.savedFailed = true
      })
    }, 800)
  }

  // Change boolean used for checking if motivational texts are used
  changeUseMotivationalTexts() {
    CvModule.setUseMotivationalTexts(this.useMotivationalTexts)
  }

  clearSelection() {
    ga.event({
      action: 'Clear selection',
      category: 'CV Tool',
      label: 'Bottom Styling'
    })
    this.$emit('clearSelect')
  }
  selectLang () {
    ga.event({
      action: 'User Selected Language',
      category: 'CV Tool',
      label: this.selectedLang
    })
  }
}
